import { render, staticRenderFns } from "./MonitoringAdministration.vue?vue&type=template&id=70f51250&scoped=true"
import script from "./MonitoringAdministration.vue?vue&type=script&lang=js"
export * from "./MonitoringAdministration.vue?vue&type=script&lang=js"
import style0 from "./MonitoringAdministration.vue?vue&type=style&index=0&id=70f51250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f51250",
  null
  
)

export default component.exports